export default "__VITE_ASSET__DxfoYOcL__"